/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { CreateDataEntryLinkRequestToJSON, DataEntryLinkRepresentationFromJSON, UpdateBatchDataEntryLinkRequestToJSON, UpdateDataEntryLinkRequestToJSON, } from '../models';
/**
 *
 */
var DataEntryLinksApi = /** @class */ (function (_super) {
    __extends(DataEntryLinksApi, _super);
    function DataEntryLinksApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create data entry link
     */
    DataEntryLinksApi.prototype.createRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createDataEntryLinkRequest === null ||
                            requestParameters.createDataEntryLinkRequest === undefined) {
                            throw new runtime.RequiredError('createDataEntryLinkRequest', 'Required parameter requestParameters.createDataEntryLinkRequest was null or undefined when calling create.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/dataEntryLinks",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: CreateDataEntryLinkRequestToJSON(requestParameters.createDataEntryLinkRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return DataEntryLinkRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create data entry link
     */
    DataEntryLinksApi.prototype.create = function (createDataEntryLinkRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRaw({ createDataEntryLinkRequest: createDataEntryLinkRequest })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete data entry links in batch
     */
    DataEntryLinksApi.prototype.deleteBatchRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
                            throw new runtime.RequiredError('requestBody', 'Required parameter requestParameters.requestBody was null or undefined when calling deleteBatch.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/dataEntryLinks/batch",
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                                body: requestParameters.requestBody,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete data entry links in batch
     */
    DataEntryLinksApi.prototype.deleteBatch = function (requestBody) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteBatchRaw({ requestBody: requestBody })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Disable data entry link
     */
    DataEntryLinksApi.prototype.disableRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.dataEntryLinkId === null || requestParameters.dataEntryLinkId === undefined) {
                            throw new runtime.RequiredError('dataEntryLinkId', 'Required parameter requestParameters.dataEntryLinkId was null or undefined when calling disable.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/dataEntryLinks/{dataEntryLinkId}/disable".replace("{".concat('dataEntryLinkId', "}"), encodeURIComponent(String(requestParameters.dataEntryLinkId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Disable data entry link
     */
    DataEntryLinksApi.prototype.disable = function (dataEntryLinkId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.disableRaw({ dataEntryLinkId: dataEntryLinkId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetch data entry link by id
     */
    DataEntryLinksApi.prototype.getRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.dataEntryLinkId === null || requestParameters.dataEntryLinkId === undefined) {
                            throw new runtime.RequiredError('dataEntryLinkId', 'Required parameter requestParameters.dataEntryLinkId was null or undefined when calling get.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/dataEntryLinks/{dataEntryLinkId}".replace("{".concat('dataEntryLinkId', "}"), encodeURIComponent(String(requestParameters.dataEntryLinkId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return DataEntryLinkRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Fetch data entry link by id
     */
    DataEntryLinksApi.prototype.get = function (dataEntryLinkId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRaw({ dataEntryLinkId: dataEntryLinkId })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetch data entry link by key
     */
    DataEntryLinksApi.prototype.getByKeyRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.dataEntryLinkKey === null || requestParameters.dataEntryLinkKey === undefined) {
                            throw new runtime.RequiredError('dataEntryLinkKey', 'Required parameter requestParameters.dataEntryLinkKey was null or undefined when calling getByKey.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/dataEntryLinks/{dataEntryLinkKey}/key".replace("{".concat('dataEntryLinkKey', "}"), encodeURIComponent(String(requestParameters.dataEntryLinkKey))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return DataEntryLinkRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Fetch data entry link by key
     */
    DataEntryLinksApi.prototype.getByKey = function (dataEntryLinkKey) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getByKeyRaw({ dataEntryLinkKey: dataEntryLinkKey })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find all data entry links
     */
    DataEntryLinksApi.prototype.listRaw = function () {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/dataEntryLinks",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(DataEntryLinkRepresentationFromJSON); })];
                }
            });
        });
    };
    /**
     * Find all data entry links
     */
    DataEntryLinksApi.prototype.list = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Refresh Data entry link
     */
    DataEntryLinksApi.prototype.refreshRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.dataEntryLinkId === null || requestParameters.dataEntryLinkId === undefined) {
                            throw new runtime.RequiredError('dataEntryLinkId', 'Required parameter requestParameters.dataEntryLinkId was null or undefined when calling refresh.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/dataEntryLinks/{dataEntryLinkId}/refresh".replace("{".concat('dataEntryLinkId', "}"), encodeURIComponent(String(requestParameters.dataEntryLinkId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Refresh Data entry link
     */
    DataEntryLinksApi.prototype.refresh = function (dataEntryLinkId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refreshRaw({ dataEntryLinkId: dataEntryLinkId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Regenerate data entry link
     */
    DataEntryLinksApi.prototype.regenerateRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.dataEntryLinkId === null || requestParameters.dataEntryLinkId === undefined) {
                            throw new runtime.RequiredError('dataEntryLinkId', 'Required parameter requestParameters.dataEntryLinkId was null or undefined when calling regenerate.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/dataEntryLinks/{dataEntryLinkId}/regenerate".replace("{".concat('dataEntryLinkId', "}"), encodeURIComponent(String(requestParameters.dataEntryLinkId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Regenerate data entry link
     */
    DataEntryLinksApi.prototype.regenerate = function (dataEntryLinkId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.regenerateRaw({ dataEntryLinkId: dataEntryLinkId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete Data entry link
     */
    DataEntryLinksApi.prototype.removeRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.dataEntryLinkId === null || requestParameters.dataEntryLinkId === undefined) {
                            throw new runtime.RequiredError('dataEntryLinkId', 'Required parameter requestParameters.dataEntryLinkId was null or undefined when calling remove.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/dataEntryLinks/{dataEntryLinkId}".replace("{".concat('dataEntryLinkId', "}"), encodeURIComponent(String(requestParameters.dataEntryLinkId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete Data entry link
     */
    DataEntryLinksApi.prototype.remove = function (dataEntryLinkId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeRaw({ dataEntryLinkId: dataEntryLinkId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update Data entry link
     */
    DataEntryLinksApi.prototype.updateRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.dataEntryLinkId === null || requestParameters.dataEntryLinkId === undefined) {
                            throw new runtime.RequiredError('dataEntryLinkId', 'Required parameter requestParameters.dataEntryLinkId was null or undefined when calling update.');
                        }
                        if (requestParameters.updateDataEntryLinkRequest === null ||
                            requestParameters.updateDataEntryLinkRequest === undefined) {
                            throw new runtime.RequiredError('updateDataEntryLinkRequest', 'Required parameter requestParameters.updateDataEntryLinkRequest was null or undefined when calling update.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/dataEntryLinks/{dataEntryLinkId}".replace("{".concat('dataEntryLinkId', "}"), encodeURIComponent(String(requestParameters.dataEntryLinkId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: UpdateDataEntryLinkRequestToJSON(requestParameters.updateDataEntryLinkRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update Data entry link
     */
    DataEntryLinksApi.prototype.update = function (dataEntryLinkId, updateDataEntryLinkRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateRaw({
                            dataEntryLinkId: dataEntryLinkId,
                            updateDataEntryLinkRequest: updateDataEntryLinkRequest,
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Update data entry links in batch
     */
    DataEntryLinksApi.prototype.updateBatchRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.updateBatchDataEntryLinkRequest === null ||
                            requestParameters.updateBatchDataEntryLinkRequest === undefined) {
                            throw new runtime.RequiredError('updateBatchDataEntryLinkRequest', 'Required parameter requestParameters.updateBatchDataEntryLinkRequest was null or undefined when calling updateBatch.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/dataEntryLinks/batch",
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: UpdateBatchDataEntryLinkRequestToJSON(requestParameters.updateBatchDataEntryLinkRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update data entry links in batch
     */
    DataEntryLinksApi.prototype.updateBatch = function (updateBatchDataEntryLinkRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateBatchRaw({ updateBatchDataEntryLinkRequest: updateBatchDataEntryLinkRequest })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return DataEntryLinksApi;
}(runtime.BaseAPI));
export { DataEntryLinksApi };
